import { skills } from '@/mocks/portfolio';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-end justify-center overflow-hidden">
      {/* Base: silk texture */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Luxurious%20silk%20fabric%20texture%20background%2C%20soft%20flowing%20pink%20and%20champagne%20gold%20folds%2C%20elegant%20draped%20satin%2C%20gentle%20curves%20and%20waves%2C%20warm%20ivory%20undertones%2C%20refined%20and%20sophisticated%2C%20editorial%20luxury%20aesthetic%2C%20high-end%20fashion%20photography%20style%2C%20soft%20diffused%20lighting%2C%20seamless%20silk%20backdrop&width=1600&height=900&seq=hero-silk-bg&orientation=landscape)',
        }}
      ></div>

      {/* Overlay: street image blended artistically */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50 mix-blend-multiply"
        style={{
          backgroundImage: 'url(https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/d900aca9-f499-4680-be5b-967ec08ee0d6_compressed_-2026-07-23-20.07.53.webp)',
        }}
      ></div>

      {/* Soft warm overlay for readability */}
      <div className="absolute inset-0 bg-warm-ivory/20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-warm-ivory/10 via-transparent to-warm-ivory/40"></div>

      {/* Gold accent line at top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-300/40 to-transparent"></div>

      {/* Content — centered, positioned in lower third */}
      <div className="relative w-full max-w-4xl mx-auto px-6 md:px-8 pt-12 pb-24 md:pt-16 md:pb-32 flex flex-col items-center text-center">
        {/* Name */}
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-charcoal-900 tracking-wide leading-none mb-3 hero-entrance hero-entrance-1">
          AMERI
        </h1>
        <p className="font-heading text-xl md:text-2xl font-semibold text-charcoal-500 tracking-wide mb-8 hero-entrance hero-entrance-2">
          アメリ
        </p>

        {/* Skills — 2 rows with slash separators */}
        <div className="flex flex-col items-center gap-y-1 max-w-xl mb-8 hero-entrance hero-entrance-3">
          <div className="flex flex-wrap items-center justify-center gap-x-2 text-sm text-charcoal-600">
            {skills.slice(0, 4).map((skill, i) => (
              <span key={skill.name} className="flex items-center whitespace-nowrap">
                {skill.name}
                {i < 3 && <span className="ml-2 text-gold-400">/</span>}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-2 text-sm text-charcoal-600">
            {skills.slice(4, 8).map((skill, i) => (
              <span key={skill.name} className="flex items-center whitespace-nowrap">
                {skill.name}
                {i < 3 && <span className="ml-2 text-gold-400">/</span>}
              </span>
            ))}
          </div>
        </div>

        {/* SNS links */}
        <div className="flex items-center gap-5 hero-entrance hero-entrance-4">
          <a
            href="https://open.spotify.com/playlist/4NIBk1d8MZ4wqHOHlNDYLF?si=00034c16fc63458e"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center bg-charcoal-800 text-white hover:bg-gold-500 transition-all duration-300 cursor-pointer rounded-full hover:scale-110"
          >
            <i className="ri-spotify-fill text-lg"></i>
          </a>
          <a
            href="https://www.instagram.com/ameri_iria?igsh=MTRxbmZkaW5tNXRocg%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center bg-charcoal-800 text-white hover:bg-gold-500 transition-all duration-300 cursor-pointer rounded-full hover:scale-110"
          >
            <i className="ri-instagram-line text-lg"></i>
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hero-entrance hero-entrance-6">
        <a
          href="#works"
          onClick={(e) => {
            e.preventDefault();
            const el = document.querySelector('#works');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="text-charcoal-300 hover:text-gold-400 transition-colors duration-300 cursor-pointer animate-bounce"
          aria-label="下へスクロール"
        >
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}